import React, { useState } from "react";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { WorkerParticulars } from "../../components/worker";

export const WorkerParticularsPage: React.FC = () => {
  const [workerName, setWorkerName] = useState("");

  return (
    <PageLayout onLogout={() => {}} style={{}}>
      {/* header — same zIndex pattern as every other single-entity page */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        {/* @ts-ignore */}
        <PageHeader title={workerName ? `${workerName} — Particulars` : "Worker Particulars"} />
      </Box>

      {/* content offset sits below the purple header band */}
      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <WorkerParticulars onWorkerNameLoaded={setWorkerName} workerName={workerName} />
      </Box>
    </PageLayout>
  );
};
